import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description YuanExchange icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { YuanExchange } from '@sravni/design-system-icons'
 *
 * <YuanExchange />
 * ```
 */
var YuanExchange = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "YuanExchange", viewBox: "0 0 20 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#YuanExchange__a)" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.11 7.72c0 .176-.008.351-.025.525l-.365-.365-1.06 1.06 1.665 1.665-.005.005c.29.29.77.29 1.06 0l-.525-.525.005-.005.53.53 1.67-1.67-.005-.005a.755.755 0 0 0-.005-1.055.754.754 0 0 0-1.06 0l.005.005-.408.408a7.07 7.07 0 0 0 .023-.573C17.61 3.43 13.97 0 9.55 0 7.34 0 5.33.86 3.87 2.25c-.3.29-.31.76-.02 1.06.29.3.76.31 1.06.02l-.01.01A6.718 6.718 0 0 1 9.55 1.5c3.65 0 6.56 2.82 6.56 6.22ZM3.205 7.595a5.632 5.632 0 0 0-.035.625c0 3.4 2.91 6.22 6.56 6.22 1.82 0 3.47-.71 4.65-1.84a.746.746 0 0 1 1.05.03.745.745 0 0 1-.015 1.055l.005.005a8.247 8.247 0 0 1-5.69 2.25c-4.42 0-8.06-3.42-8.06-7.72 0-.236.012-.467.034-.694l-.424.424c-.29.29-.77.29-1.06 0a.754.754 0 0 1 0-1.06l1.67-1.67a.75.75 0 0 1 1.06 0l1.67 1.67c.29.29.29.77 0 1.06-.29.29-.77.29-1.06 0l-.355-.355Zm12.505.285a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l1.06-1.06Zm-2.83-2.958a.75.75 0 1 0-1.28-.784L9.745 7.166 7.846 4.132a.75.75 0 1 0-1.272.796l2.424 3.874-.003.418H7.65a.75.75 0 0 0 0 1.5h1.332l-.012 1.353a.75.75 0 0 0 1.5.013l.012-1.366h1.338a.75.75 0 0 0 0-1.5h-1.325l.003-.415 2.381-3.883Z", fill: "currentColor" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "YuanExchange__a" },
            React.createElement("path", { fill: "currentColor", d: "M0 0h19.28v15.94H0z" }))))); });

export { YuanExchange };
//# sourceMappingURL=YuanExchange.js.map
